import { RadioGroup } from '@headlessui/react';
import React from 'react';
import { FormControlProps } from '../../FormControl/FormControl';
import ChoiceCardInnerRadioGroup from './ChoiceCardInnerRadioGroup';
import { ToggleProvider } from '../../../context/ToggleGroupContext';

export type ChoiceCardRadioGroupProps = {
  value?: string;
  onChange: (selected: string | undefined) => void;
} & Omit<FormControlProps, 'as'>;

const ChoiceCardRadioGroup = ({
  value,
  onChange,
  children,
  disabled,
  ...props
}: ChoiceCardRadioGroupProps) => {
  return (
    <ToggleProvider disabled={disabled}>
      <RadioGroup value={value} onChange={onChange}>
        <ChoiceCardInnerRadioGroup {...props}>
          {children}
        </ChoiceCardInnerRadioGroup>
      </RadioGroup>
    </ToggleProvider>
  );
};

ChoiceCardRadioGroup.displayName = 'ChoiceCardRadioGroup';
export default ChoiceCardRadioGroup;
